import logger from './Logger';

export default (executor, defaultValue, reportError = true) => {
  try {
    const result = executor();
    if (result === undefined) return defaultValue;
    return result;
  } catch (err) {
    if (reportError) {
      logger.error(err);
    }
    return defaultValue;
  }
};



// WEBPACK FOOTER //
// ./src/utils/getObjectProperty.js